import React from "react";
import styles from "./Home.module.scss";
import Slider from "react-slick";
import CarouselCards from "../../components/CarouselCards/CarouselCards";
// import HomeBelowCards from "../../components/HomeBelowCards/HomeBelowCards";
import CallToAction from "../../components/CallToAction/CallToAction";
const carouselData = [
  {
    title: "Empower Your Business",
    description: `Unlock the power of data with SealKloud by transforming insights into action and drive your business forward.`,
    bgImage: "/assests/solutions-hero-banner-bg.jpg",
  },
  {
    title: "Innovate with SAP",
    description: `Stay ahead of the competion, future proof  your business by levaraging  SealKloud's expertise in SAP Technology solutions.`,
    bgImage: "/assests/solutions-hero-banner-bg.jpg",
  },
  {
    title: "Optimize operations",
    description:
      "Experience enhanced efficiency and productivity across your organisation with SealKloud, by streamline your SAP operations. ",
    bgImage: "/assests/solutions-hero-banner-bg.jpg",
  },
  {
    title: "Customer Centric Solutions",
    description:
      "Personalize interactions and build lasting relationships with SealKloud by exceptional customer experiences.",
    bgImage: "/assests/solutions-hero-banner-bg.jpg",
  },
  {
    title: "Scalable Success",
    description:
      "Enjoy peace of mind while Sealkloud ensures current SAP solutions align with your future business needs ",
    bgImage: "/assests/solutions-hero-banner-bg.jpg",
  },
];
// const homeBelowCards = [
//   {
//     title: "Our Vision",
//     description: `Be the foremost provider of innovative and transformative enterprise solutions. We aspire to create a future where businesses seamlessly integrate advanced technologies, achieve unparalleled operational excellence, and continuously adapt to emerging market trends. Through our expertise, we envision being the driving force behind our clients' sustained success and evolution`,
//     bgImage: "/assests/our_vision.jpg",
//   },
//   {
//     title: "Our Mission",
//     description:
//       "Be the catalyst for organizational growth, enabling our clients to navigate the complexities of the digital landscape with confidence and efficiency.",
//     bgImage: "/assests/our_mission.jpg",
//     reverseOrder:true,
//   },
// ];
const Home = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
    autoplay: true,
  };
  return (
    <section className={styles.Home}>
      {/* <OurStory/> */}
      <Slider {...settings}>
        {carouselData.map((carousel) => (
          <CarouselCards
            key={carousel.id} // Add a unique key for each item (assuming carousel has an id or unique identifier)
            title={carousel.title}
            description={carousel.description}
            bgImage={carousel.bgImage}
          />
        ))}
      </Slider>
      {/* {homeBelowCards.map((card) => (
        <HomeBelowCards {...card} />
      ))} */}
      <CallToAction />
    </section>
  );
};
export default Home;
